import useScreen from 'hooks/useScreen';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useSelectedLanguage from 'store/language';
import useWebsiteSports, { SportProviders } from 'store/websiteSports';
import useSettings from 'store/settings';
import useSelectedTheme from 'store/theme';

const ODD_TYPE = 'widgetCoefficientClicked';
const EVENT_TYPE = 'widgetEventClicked';

const OneXBetWidget = () => {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const navigate = useNavigate();
  const [{ selectedLanguage }] = useSelectedLanguage();
  const [{ data: settings }] = useSettings();
  const [{ isDark }] = useSelectedTheme();

  const { isMobile } = useScreen();
  const [sportState] = useWebsiteSports();
  const [isLoaded, setIsLoaded] = useState(false);

  const { url } = sportState.data.find((sport) => sport.id === SportProviders.ONE_X_BET) || {};

  useEffect(() => {
    if (!isLoaded) return;

    const handler = (event: MessageEvent) => {
      if (event.origin === url) {
        switch (event.data.event) {
          case ODD_TYPE: {
            const { pathname } = new URL(event.data.url);
            navigate(`/sport/${SportProviders.ONE_X_BET}?tab=${pathname}`);
            break;
          }
          case EVENT_TYPE: {
            const { pathname } = new URL(event.data.url);
            navigate(`/sport/${SportProviders.ONE_X_BET}?tab=${pathname}`);
            break;
          }
          default:
            break;
        }
      }
    };

    window.addEventListener('message', handler);

    return () => {
      window.removeEventListener('message', handler);
    };
  }, [isLoaded]);

  if (!url || !selectedLanguage) return null;

  const result = new URL(`${url}/${selectedLanguage?.iso_1}/widget/top-events/live`);
  result.searchParams.append('lng', selectedLanguage?.iso_1);
  result.searchParams.append('platform_type', isMobile ? 'mobile' : 'desktop');
  result.searchParams.append('bgColor', isDark ? settings?.mainColorDark : settings?.mainColor);

  return (
    <iframe
      onLoad={() => setIsLoaded(true)}
      style={{
        width: '100%',
        border: 'none',
        height: isMobile ? '185px' : '175px',
        marginTop: '10px',
      }}
      ref={ref}
      src={result.toString()}
    />
  );
};

export default OneXBetWidget;
